import { styled } from '../../config'

export const Divider = styled('hr', {
  borderWidth: '0px 0px 1px',
  width: '100%',
  color: '$whiteA100',
  borderStyle: 'solid'
})
